window.addEventListener('load', function () {
    const desktopSections = document.querySelectorAll("main section:not(#garden-section)");
    const mobileSections = document.querySelectorAll("main section");
    const navLi = document.querySelectorAll("#product-nav .nav-item");
    let activeLi = false;

    navLi.forEach(link => {
        if (!link.classList.contains('hidden')) {
            activeLi = true;
        }
    });

    if (activeLi == true) {
        document.querySelector('.product-navigation-container').classList.remove('hidden');
    }

    if (screen.width >= 767) {
        window.onscroll = () => {
            var current = "";
            
            desktopSections.forEach((section) => {                
                const sectionTop = section.offsetTop;
                if (pageYOffset >= sectionTop - 200) {
                    current = section.getAttribute("id");
                } 
            });

            navLi.forEach((li) => {
                if (current != "garden-section") {
                    let classListing = li.classList;

                    if (li.classList.contains(current)) {
                        li.classList.add("active");
                    } else {
                        li.classList.remove("active");
                    }
                }
            });
        };
    } else {
        window.onscroll = () => {
            var current = "";
            
            mobileSections.forEach((section) => {
                const sectionTop = section.offsetTop;
                if (pageYOffset >= sectionTop - 200) {
                    current = section.getAttribute("id");
                }
            });

            navLi.forEach((li) => {
                let classListing = li.classList;

                if (li.classList.contains(current)) {
                    li.classList.add("active");
                } else {
                    li.classList.remove("active");
                }
            });
        };
    }

    var button = document.getElementById('nav-arrow-right');
    button.onclick = function () {
        var container = document.getElementById('product-nav-list');
        sideScroll(container,'right',10,175,10);
    };

    var back = document.getElementById('nav-arrow-left');
    back.onclick = function () {
        var container = document.getElementById('product-nav-list');
        sideScroll(container,'left',10,175,15);
    };

    function sideScroll(element,direction,speed,distance,step){
        scrollAmount = 0;
        var slideTimer = setInterval(function(){
            if(direction == 'left'){
                element.scrollLeft -= step;
            } else {
                element.scrollLeft += step;
            }
            scrollAmount += step;
            if(scrollAmount >= distance){
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    function setActiveMenuItem() {
        const scrollPosition = window.scrollY;
        const menuItems = document.querySelectorAll('#product-nav-list li');
        const menu = document.getElementById('product-nav-list');

        menuItems.forEach(item => {
            const sectionId = item.id;
            const section = document.getElementById(sectionId);

                if (item.classList.contains('active')) {
                    console.log('active container', item);
                    console.log('offest amount', item.offsetLeft);
                    menu.scrollLeft = item.offsetLeft - 50;
                }
        });
    };
    window.addEventListener('scroll', setActiveMenuItem);
});